import React from 'react'

function PatientSearchPage() {
  return (
    <div>PatientSearchPage</div>
  )
}

export default PatientSearchPage